import HAModal from "./HAModal.presenter";
export default HAModal;
